import React from 'react';

// Define a type for the props
type ControlPanelProps = {
  file: string; // Assuming file is a string, adjust if it's another type
  pageNumber: number;
  numPages: number | undefined;
  setPageNumber: (pageNumber: number) => void;
  scale: number;
  setScale: (scale: number) => void;
};

const ControlPanel: React.FC<ControlPanelProps> = ({ file, pageNumber, numPages, setPageNumber, scale, setScale }) => {
  const isFirstPage = pageNumber === 1;
  const isLastPage = pageNumber === numPages;

  // const firstPageClass = isFirstPage ? 'disabled' : 'clickable';
  // const lastPageClass = isLastPage ? 'disabled' : 'clickable';

  // const goToFirstPage = () => {
  //   if (!isFirstPage) setPageNumber(1);
  // };

  const goToPreviousPage = () => {
    if (!isFirstPage && pageNumber) setPageNumber(pageNumber - 1);
  };
  const goToNextPage = () => {
    if (!isLastPage && pageNumber) setPageNumber(pageNumber + 1);
  };

  // const goToLastPage = () => {
  //   if (!isLastPage && numPages) setPageNumber(numPages);
  // };

  const onPageChange = (e: any) => {
    const { value } = e.target;
    setPageNumber(Number(value));
  };

  const isMinZoom = scale < 0.6;
  const isMaxZoom = scale >= 2.0;

  const zoomOutClass = isMinZoom ? 'disabled' : 'clickable';
  const zoomInClass = isMaxZoom ? 'disabled' : 'clickable';

  const zoomOut = () => {
    if (!isMinZoom) setScale(scale - 0.1);
  };

  const zoomIn = () => {
    if (!isMaxZoom) setScale(scale + 0.1);
  };

  return (
    <div className="flex  justify-between  w-full border-b-2 border-gray-400 py-[0.5rem]">
      <div>
        Preview contract
        <a href={file} download={true} title="download">
          <i className="ms-[1rem] fas fa-download"></i>
        </a>
      </div>

      <div className="flex">
        <div className="flex space-x-[1rem]">
          <img
            title="prev page"
            src="/assets/icons/flat/chevron_left.svg"
            onClick={goToPreviousPage}
            className="-rotate-90"
          />
          <img
            title="prev page"
            src="/assets/icons/flat/chevron_left.svg"
            onClick={goToNextPage}
            className="rotate-90"
          />
        </div>
        <span className="mx-[1.875rem]">{(scale * 100).toFixed()}%</span>
        <div className="space-x-[1rem]">
          <i className={`fas fa-minus  ${zoomOutClass}`} onClick={zoomOut} />
          <i className={`fas fa-plus  ${zoomInClass}`} onClick={zoomIn} />
        </div>
      </div>
      <div>
        <span className="flex">
          <input
            title="page number"
            name="pageNumber"
            type="text"
            min={1}
            max={numPages || 1}
            className="p-0 pl-1 mx-2 w-4"
            value={pageNumber}
            onChange={onPageChange}
          />{' '}
          of <span className="ms-3">{numPages}</span>
        </span>
      </div>
    </div>
  );
};

export default ControlPanel;
